import type { SuburbInput } from "@repo/adapter-core";
import type { SoldOnlyAdapterConfig } from "../shared/sold-only.ts";

export function buildSearchUrl(suburb: SuburbInput, _config: SoldOnlyAdapterConfig): string {
  return `https://www.kayburton.com.au/sell/sold-properties/?suburb=${encodeURIComponent(suburb.locality)}&postcode=${suburb.postcode}`;
}

// Page N is a path segment before the query: /sell/sold-properties/page/2/?suburb=…&postcode=…
// keeps the suburb filter (Brighton page 2: 20 new sales, 2026-10-14). The registry's default
// `&page=N` is ignored by the site and repeated page 1.
export function buildPaginatedUrl(searchUrl: string, page: number): string {
  if (page <= 1) return searchUrl;
  const url = new URL(searchUrl);
  url.pathname = `${url.pathname.replace(/page\/\d+\/$/, "")}page/${page}/`;
  return url.toString();
}
